import { SubtypeDefinition, SchedulingStrategyDefinition, RewardCalculationTypeDefinition, IncentivationSourceDefinition } from "./actionModule";
import { PropertyTypes, SubtypeProperty } from "./editor/subtypeEditorTypes";
import { ManualActionIncentivationSource } from "./incentivationSource/manualActionIncentivationSource";
import { FixedRewardCalculationType } from "./rewardCalculationType/fixedRewardCalculationType";
import { ManualInputRewardCalculationType } from "./rewardCalculationType/manualInputRewardCalculationType";
import { MaxPointsRewardCalculationType } from "./rewardCalculationType/maxPointsRewardCalculationType";
import { PercentMaxPointsRewardCalculationType } from "./rewardCalculationType/percentMaxPointsRewardCalculationType";
import { ScoreMultiplyRewardCalculationType } from "./rewardCalculationType/scoreMultiplyRewardCalculationType";
import { ScoreRangeRewardCalculationType } from "./rewardCalculationType/scoreRangeRewardCalculationType";
import { SplitMaxPointsRewardCalculationType } from "./rewardCalculationType/splitMaxPointsRewardCalculationType";
import { AfterEmployeeCreationSchedulingStrategy } from "./schedulingStrategy/afterEmployeeCreationSchedulingStrategy";
import { DefinedBySubtypeSchedulingStrategy } from "./schedulingStrategy/definedBySubtypeSchedulingStrategy";
import { RepeatPatternSchedulingStrategy } from "./schedulingStrategy/repeatPatternSchedulingStrategy";
import { ScheduleDefinitionSchedulingStrategy } from "./schedulingStrategy/scheduleDefinitionSchedulingStrategy";
import { AnniversaryBonusSubtype } from "./subtypes/anniversaryBonusSubtypeDefinition";
import { BirthdayBonusSubtype } from "./subtypes/birthdayBonusSubtypeDefinition";
import { ChecklistAnswerSubtype } from "./subtypes/checklistAnswerSubtypeDefinition";
import { DateSubtype } from "./subtypes/dateSubtypeDefinition";
import { DropdownAnswerSubtype } from "./subtypes/dropdownAnswerSubtypeDefinition";
import { EvaluationStarsSubtype } from "./subtypes/evaluationStarsSubtypeDefinition";
import { EvaluationThumbsSubtype } from "./subtypes/evaluationThumbsSubtypeDefinition";
import { LinkSubtype } from "./subtypes/linkSubtype";
import { MonthlyTaxFreeBenefitSubtype } from "./subtypes/monthlyTaxFreeBenefitSubtype";
import { MultiPictureUploasSubtype } from "./subtypes/multiPictureUploadSubtypeDefinition";
import { PictureUploadSubtype } from "./subtypes/pictureUploadSubtypeDefinition";
import { SurveyAppointmentSubtype } from "./subtypes/surveyAppointmentSubtypeDefinition";
import { TextAnswerModuleSubtype } from "./subtypes/textAnswerSubtypeDefinition";

/*
 * Collection of all implemented subtypes. Add new subtypes to this list
 */
export const subtypes: SubtypeDefinition[] = [
    AnniversaryBonusSubtype,
    BirthdayBonusSubtype,
    ChecklistAnswerSubtype,
    EvaluationStarsSubtype,
    EvaluationThumbsSubtype,
    LinkSubtype,
    MonthlyTaxFreeBenefitSubtype,
    MultiPictureUploasSubtype,
    PictureUploadSubtype,
    SurveyAppointmentSubtype,
    TextAnswerModuleSubtype,
    DropdownAnswerSubtype,
    DateSubtype
]

/*
 * Collection of all implemented scheduling strategies. Add new schedulingStrategies to this list
 */
export const schedulingStrategies: SchedulingStrategyDefinition[] = [
    RepeatPatternSchedulingStrategy,
    ScheduleDefinitionSchedulingStrategy,
    AfterEmployeeCreationSchedulingStrategy,
    DefinedBySubtypeSchedulingStrategy,
]

/*
 * Collection of all implemented reward calculation types. Add new reward calculation types to this list
 */
export const rewardCalculationTypes: RewardCalculationTypeDefinition[] = [
    FixedRewardCalculationType,
    ManualInputRewardCalculationType,
    MaxPointsRewardCalculationType,
    PercentMaxPointsRewardCalculationType,
    ScoreMultiplyRewardCalculationType,
    ScoreRangeRewardCalculationType,
    SplitMaxPointsRewardCalculationType,
];

/*
 * Collection of all implemented incentivation sources. Add new incentivation sources to this list
 */
export const incentivationSources: IncentivationSourceDefinition[] = [
    ManualActionIncentivationSource,
];

/*
 * Base properties which are shared among all subtypes.
 */
export const subtypeDefaultProperties: SubtypeProperty[] = [
    {
        name: "isRequiredForCompletionByEmployee",
        displayName: "actionModules.subtypes.base.isRequiredForCompletionByEmployee",
        propertyType: PropertyTypes.boolean,
        defaultValue: true,
    },
    {
        name: "isRequiredForCompletionByCompanyManagment",
        displayName: "actionModules.subtypes.base.isRequiredForCompletionByCompanyManagement",
        propertyType: PropertyTypes.boolean,
        defaultValue: false,
    },
    {
        name: "name",
        displayName: "actionModules.subtypes.base.name",
        propertyType: PropertyTypes.text,
    },
    {
        name: "randomizationGroup",
        displayName: "actionModules.subtypes.base.randomizationGroup",
        propertyType: PropertyTypes.integer,
    },
    {
        name: "importColumnName",
        displayName: "actionModules.subtypes.base.importColumnName",
        propertyType: PropertyTypes.text,
    },
    {
        name: "conditionSubtypeId",
        displayName: "actionModules.subtypes.base.conditionSubtypeId",
        propertyType: PropertyTypes.complex,
        defaultValue: null,
    },
    {
        name: "conditionChecklistItemId",
        displayName: "actionModules.subtypes.base.conditionChecklistItemId",
        propertyType: PropertyTypes.complex,
        defaultValue: null,
    },
    {
        name: "negateCondition",
        displayName: "actionModules.subtypes.base.negateCondition",
        propertyType: PropertyTypes.boolean,
        defaultValue: false,
    },
]